<template>
    <v-container class="documents">
        <v-layout row wrap>
            <v-flex xs12 lg8 offset-lg2>
                <section v-if="$store.state.mandate.url" class="my-4">
                    <v-card>
                        <v-list two-line subheader>
                            <v-subheader>Dokumente - Allgemein</v-subheader>

                            <v-list-tile v-if="number_of_contracts_is_mandate_with_kind_company>0" avatar>
                                    <v-list-tile-avatar>
                                        <v-icon class="red white--text">screen_share</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <a :href="`${mandate_url}&type=company`" download="company-mandante.pdf" target="_blank" class="d-block w-100">
                                            <v-list-tile-title>Maklervertrag Unternehmen</v-list-tile-title>
                                            <v-list-tile-sub-title>vom: {{ $store.state.mandate.published_date }}</v-list-tile-sub-title>
                                        </a>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-menu bottom left>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon v-on="on"><v-icon>more_vert</v-icon></v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-tile :ripple="{ class: 'black--text' }" :href="`${mandate_url}&type=company`" target="_blank">
                                                    <v-list-tile-title><v-icon left>open_in_new</v-icon> Im neuen Tab öffnen</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                                    </v-list-tile-action>
                            </v-list-tile>

                            <v-list-tile v-if="number_of_contracts_is_mandate_with_kind_private>0" avatar>
                                    <v-list-tile-avatar>
                                        <v-icon class="red white--text">screen_share</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <a :href="`${mandate_url}&type=private`" download="private-mandante.pdf" target="_blank" class="d-block w-100">
                                            <v-list-tile-title>Maklervertrag Privat</v-list-tile-title>
                                            <v-list-tile-sub-title>vom: {{ $store.state.mandate.published_date | moment("DD.MM.YYYY") }}</v-list-tile-sub-title>
                                        </a>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-menu bottom left>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon v-on="on"><v-icon>more_vert</v-icon></v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-tile :ripple="{ class: 'black--text' }" :href="`${mandate_url}&type=private`" target="_blank">
                                                    <v-list-tile-title><v-icon left>open_in_new</v-icon> Im neuen Tab öffnen</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                                    </v-list-tile-action>
                            </v-list-tile>
                        </v-list>
                    </v-card>
                </section>


                <div v-for="contract in contractlist" :key="contract.id" class="py-1">
                    <ContractDocumentsCard v-if="contract.id && contract.kind && contract.status!='Angebot'" ref="ContractDocumentsCard" :contract="contract" :heading="`${contract.kind}${contract.productpartner.name ? ' - '+contract.productpartner.name : ''}`" />
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { API_URL_BASE, IS_MOBILE } from '@/constants.js'
import ContractDocumentsCard from '@/components/ContractDocumentsCard'

export default {
    data() {
        return {
            mandate_url: '#!'
        }
    },


    computed: {
        contractlist(){
            // let list = _.filter(this.$store.getters['contracts/getAllContracts'], function(row) { return row.is_published && row.status!='Vertrag abgelaufen'; });
            // let sortening_list = _.filter(list, function(row) { return row.color!='red'; });
            // list = _.filter(list, function(row) { return row.color=='red'; });
            // sortening_list = _.reverse(_.sortBy(sortening_list, ['status_date', 'published_date']));
            // return sortening_list.concat(list);
            return this.$store.getters['contracts/getAllContracts'];
        },
        contracts_is_mandate__true(){
            return _.filter(this.$store.getters['contracts/getAllContracts'], function(o) { return o.is_mandate==1 });
        },
        contracts_is_mandate__false(){
            return _.filter(this.$store.getters['contracts/getAllContracts'], function(o) { return o.is_mandate==0 });
        },
        number_of_contracts_is_mandate_with_kind_company(){
            let tmp = _.filter(this.contracts_is_mandate__true, ['type', 'company']);
            return tmp ? tmp.length : 0;
        },
        number_of_contracts_is_mandate_with_kind_private(){
            let tmp = _.filter(this.contracts_is_mandate__true, ['type', 'private']);
            return tmp ? tmp.length : 0;
        },
        isMobile(){
            return IS_MOBILE();
        }
    },


    components: {
        ContractDocumentsCard
    },


    created(){
        this.getMandateUrl();
    },


    methods: {
        getMandateUrl(){
            // return `${API_URL_BASE}f_api/getMandatePdf.php?uid=${this.$store.state.auth.fb.uid}&type=${type}`
            this.$store.dispatch('auth/getAxiosConfig4Api', false).then(config => {
                this.mandate_url = `${API_URL_BASE}f_api/showMandateContract.php?token=${config.headers.Authorization.substr(7)}`;
            });
        }
    }
}
</script>

<style scoped>
    a.d-block.w-100{
        text-decoration:none;
        color:inherit;
    }
    .v-list__tile__avatar .v-avatar > .v-icon{
        font-size:2rem;
    }
</style>
